import {useSelector} from "react-redux";
import {Field} from "formik";
import {FormattedMessage} from "react-intl";
import {Select} from "../../../../../_metronic/_partials/controls";
import {AsOption} from "../../../partials/FormattedMessages";
import React from "react";

export const SupervisorSelect = ({name = 'supervisor', emptyOption = null, submitOnChange = false, metaSection = 'students'}) => {

    const supervisors = useSelector(state => state?.[metaSection]?.meta?.supervisors ?? [])

    return <Field
        label={<FormattedMessage
            id="PTBP.SUPERVISOR.SUPERVISOR_OWNER"
        />}
        name={name}
        key={name}
    >
        {
            ({field, form}) => {
                return <Select value={field.value ?? ''}
                               onChange={e => {
                                   form.setFieldValue(field.name, e.currentTarget.value);

                                   if (submitOnChange) {
                                       form.submitForm().then(r => {
                                       });
                                   }

                               }}>
                    {emptyOption || <AsOption>
                        <FormattedMessage
                            id="PTBP.SUPERVISOR.SELECT_SUPERVISOR"
                            defaultMessage="Seleziona supervisore"
                        />
                    </AsOption>}
                    {
                        supervisors.map(el => <option value={el.id}>{el.name}</option>)
                    }
                </Select>;
            }
        }
    </Field>;
};
